var API_DOMAIN = "https://shridevifinance.zentexus.com/api";
// var API_DOMAIN = "http://localhost/shridevifinance/api";

export default API_DOMAIN;
